<tool-drawer-container (openFormDialog)="openDialog()">
  <financial-aid-form class="form-slot"></financial-aid-form>

  <financial-aid-main-content
    class="tool-header"
    tool="financial aid"
  ></financial-aid-main-content>

  <financial-aid-tool-content class="main-content"></financial-aid-tool-content>
</tool-drawer-container>
